<script>
  import { mapGetters } from 'vuex'
  import { HeadMeta } from '@/utils/head-meta'
  import { routeSlugs } from '@/utils/routes-translations'

  import ProductGrid from '@/components/Ecommerce/Products/ProductGrid.vue'

  export default {
    components: {
      ProductGrid
    },
    head () {
      return HeadMeta({
        title: 'Producten',
        metaDescription:
          'Slagen voor je eindexamens doe je met Examenbundel, Samengevat, Examenidioom en Zeker Slagen! Met meer dan 40 jaar ervaring weten we wat belangrijk is!'
      })
    },
    computed: {
      ...mapGetters({
        currentPage: 'products/currentPage',
        totalPages: 'products/totalPages'
      })
    },
   
    methods: {
      handlePageChange (num) {
        if (num === 1) {
          this.$router.push(routeSlugs.products)
        }
        const routeName = this.$route.name + (this.$route.params.id ? '' : '-page-id')
        this.$router.push({
          name: routeName,
          params: { id: num },
          query: this.$route.query
        })
      }
    }
  }
</script>

<template>
  <article class="view view-products ">
    <header class="view-header">
      <div class="container px-4 md:px-8">
        <animated-title>
          <h1 class="pb-4 text-3xl animate md:text-5xl md:text-center">
            Producten
          </h1>
        </animated-title>
      </div>
    </header>
    <ProductGrid :key="$route.fullPath" />
  </article>
</template>

<style lang="scss">
.view-products.view {
  @apply pb-0;
}
</style>
